import React from 'react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_TOTAL, OFFER_ANCHOR, PRICE, PRODUCT_NAME } from '../data/content';
export function FinalCTA() {
  return <section aria-labelledby="cierre" className="bg-ink" data-id="element-58" data-mp="c70xva6rjfok">
      <div className="mx-auto max-w-xl px-3 py-5 text-center sm:px-5" data-id="element-59" data-mp="c4fu2fmwmpo6">
        <h2 id="cierre" className="font-display text-[1.5rem] font-extrabold leading-none tracking-tight text-highlight sm:text-4xl" data-id="element-60" data-mp="83m7bpl77gwv">
          Una última oportunidad
        </h2>
        <p className="mx-auto mt-2 max-w-xl text-sm leading-snug text-white/90" data-id="element-61" data-mp="h5loqj04kn0c">
          Podés seguir guardando videos sobre asientos contables, balances,
          Monotributo, IVA, sueldos e impuestos sin saber qué deberías aprender
          primero. O podés comenzar hoy a construir conocimientos prácticos
          siguiendo una ruta organizada desde cero.
        </p>
        <p className="mx-auto mt-1.5 max-w-xl font-sub text-sm font-semibold leading-snug text-white" data-id="element-62" data-mp="zxo7bzwbudd8">
          No necesitás ser experto en contabilidad para empezar.{' '}
          <span className="text-highlight" data-id="element-63" data-mp="2h37zx4tb4x29">Necesitás dar el primer paso.</span>
        </p>

        <Reveal className="mt-3 rounded-2xl border-4 border-dashed border-cta bg-white p-3 text-ink" data-id="element-64" data-mp="2m2b3ektn2v84">
          <p className="font-display text-sm font-extrabold uppercase leading-tight text-brand" data-id="element-65" data-mp="2r2gotj9bflhr">
            {PRODUCT_NAME}
          </p>
          <p className="mt-1 inline-block rounded-md bg-highlight px-2 py-0.5 font-display text-2xl font-extrabold leading-tight" data-id="element-66" data-mp="2v2zhtgmy2xlj">
            6 Tomos + 5 Bonos
          </p>
          <p className="mt-1 text-xs font-semibold text-ink/80 sm:text-sm" data-id="element-67" data-mp="34t2b7hxzadke">
            Valor de los bonos:{' '}
            <span className="line-through decoration-2" data-id="element-68" data-mp="39r3sbxbug2t8">{BONUS_TOTAL}</span>
          </p>
          <p className="mt-1 font-display text-5xl font-black leading-none text-cta sm:text-6xl" data-id="element-69" data-mp="3esjb1iqjtx8g">
            <span className="text-2xl text-ink sm:text-3xl" data-id="element-70" data-mp="3iu4vpq9brft7">Hoy:</span>{' '}
            {PRICE}
          </p>

          <CtaButton href={OFFER_ANCHOR} size="lg" className="mt-3" data-id="element-71" data-mp="1jp4wpxmojdr1">
            🚀 Sí, quiero comenzar ahora
          </CtaButton>

          <p className="mt-2.5 text-xs font-semibold text-ink/80" data-id="element-72" data-mp="1en5tcnqxwgu3">
            Acceso Inmediato • Entrega Digital • Garantía de 7 Días
          </p>
        </Reveal>
      </div>
    </section>;
}